// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\Shares\ApiShare.cs
export enum ShareScope { 
    Public = 1,
    User = 2,
    Organization = 3
}

export const ShareScopeDisplayName : { [val : number] : string } = { 
    1: 'Public',
    2: 'User',
    3: 'Organization'
}

export const ShareScopes : { Id : ShareScope, Name : string }[] = [ 
    { Id: ShareScope.Public, Name: 'Public' },
    { Id: ShareScope.User, Name: 'User' },
    { Id: ShareScope.Organization, Name: 'Organization' }
]



// WEBPACK FOOTER //
// ./server/enums/ShareScope.ts